export const DEFAULT_THUMBNAIL = 'https://panel.sesja.pl/images/sesja.jpg';
